import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const FlexWrapper = styled(Flex)`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.previewLayer};
  width: 100vw;
  height: 100vh;

  background: rgb(79 88 96 / 50%);
`;

export const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const slide = keyframes`
  0% {left: 0;}
  50% {left: calc(100% - 50px)}
  100% {left:0}
`;

export const HandAnimation = styled.div`
  position: absolute;
  top: 100%;
  width: 50px;
  height: 50px;

  animation: ${slide} 1.5s ease-in-out infinite;
`;

export const DescriptionWrapper = styled.div`
  padding-top: 250px;
`;
